export default function StatusBar({ statusMsg }) {
  if (!statusMsg) return null;

  return <div className="statusBar">{statusMsg}</div>;
}
